import ProcessIMG1 from  '../../../assets/images/nas-process-1.png'
import ProcessIMG2 from  '../../../assets/images/nas-process-2.png'
import ProcessIMG3 from  '../../../assets/images/nas-process-3.png'
import ProcessIMG4 from  '../../../assets/images/nas-process-4.png'
import ProcessIMG5 from  '../../../assets/images/nas-process-5.png'
import ProcessMobile1 from '../../../assets/images/itm01.png';
import ProcessMobile2 from '../../../assets/images/itm02.png';
import ProcessMobile3 from '../../../assets/images/itm03.png';
import ProcessMobile4 from '../../../assets/images/itm04.png';
import ProcessMobile5 from '../../../assets/images/itm05.png';

import { Service } from './types';

export const services: Service[] = [
  {
    id: 1,
    icon: ProcessMobile1,
    mobileIcon: ProcessMobile1,
    alt: 'IT Monkeys Data Leaks',
    title: 'Communication initiale',
    titleKey: 'dataCyber.timeline.services.1.title',
    description: 'Sélection des données à surveiller. Adresses e-mail, noms de domaine, adresses ip ou toute autre donnée clé.',
    descriptionKey: 'dataCyber.timeline.services.1.description',
    link: '/#',
    features: [
      { text: '' },
      { text: "Informations définies par le client." },
      { text: 'Données clés ciblées.' },
      { text: 'Déclenchement de la surveillance.' },
    ],
  },
  {
    id: 2,
    icon: ProcessMobile2,
    mobileIcon: ProcessMobile2,
    alt: 'Cybersecurity Icon',
    title: 'Surveillance proactive',
    titleKey: 'dataCyber.timeline.services.2.title',
    description: 'Notre dispositif commence à surveiller activement le web pour détecter toute divulgation.',
    descriptionKey: 'dataCyber.timeline.services.2.description',
    link: '/#',
    features: [
      { text: '' },
      { text: 'Analyse continue.' },
      { text: 'Identification des fuites.' },
      { text: 'Alertes en temps réel.' },
    ],
  },
  {
    id: 3,
    icon: ProcessMobile3,
    mobileIcon: ProcessMobile3,
    alt: 'Cloud Service Icon',
    title: 'Intervention des analystes',
    titleKey: 'dataCyber.timeline.services.3.title',
    description: 'En cas de fuite, notre équipe d\'analystes évalue la pertinence et la gravité de la fuite.',
    descriptionKey: 'dataCyber.timeline.services.3.description',
    link: '/#',
    features: [
      { text: '' },
      { text: 'Vérification et validation.' },
      { text: "Analyse de l'impact." },
      { text: 'Classification entre menaces réelles et faux positifs.' }
    ],
  },
  {
    id: 4,
    icon: ProcessMobile4,
    mobileIcon: ProcessMobile4,
    alt: 'OpenAI Icon',
    title: 'Prise en charge des incidents',
    titleKey: 'dataCyber.timeline.services.4.title',
    description: 'Historique de la fuite, élaboration de recommandations précises.',
    descriptionKey: 'dataCyber.timeline.services.4.description',
    link: '/#',
    features: [
      { text: '' },
      { text: 'Plan de réponse adapté.' },
      { text: 'Rapport détaillé fourni.' },
      { text: 'Sources identifiées.' },
    ],
  },
  {
    id: 5,
    icon: ProcessMobile5,
    mobileIcon: ProcessMobile5,
    alt: 'Training Icon',
    title: 'Correction et suivi post-détection',
    titleKey: 'dataCyber.timeline.services.5.title',
    description: 'Sur devis, mise en oeuvre des mesures de correction nécessaires sur votre SI.',
    descriptionKey: 'dataCyber.timeline.services.5.description',
    link: '/training',
    features: [
      { text: '' },
      { text: 'Équipe d\'intervention qualifiée.' },
      { text: 'Application de correctifs.' },
      { text: 'Vérification post-intervention .' },
    ],
  },
];
